import { requestFetch } from '@repo/common-utils';
import { WorkingPlatform } from '@repo/platform';

export const getContent = async (id: string) => {
  return requestFetch(`${process.env.NEXT_PUBLIC_SENA_API_SERVER}/api/old/contents/${id}`, undefined, { cache: 'no-store' });
};

export const getContents = (page: number, workingPlatform?: WorkingPlatform, categoryFilter?: string) => {
  const params = new URLSearchParams({ page: page.toString() });
  if (workingPlatform) {
    params.append('working_platform', workingPlatform);
  }
  if (categoryFilter) {
    params.append('category_filter', categoryFilter);
  }
  return requestFetch(`${process.env.NEXT_PUBLIC_SENA_API_SERVER}/api/old/contents?${params.toString()}`, undefined, { next: { revalidate: 300 } });
};

export const getContentCategory = (category?: string, signal?: AbortSignal) => {
  const params = new URLSearchParams();
  if (category) {
    params.append('category', category);
  }
  return requestFetch(`${process.env.NEXT_PUBLIC_SENA_API_SERVER}/api/old/contents/filters?${params.toString()}`, undefined, signal ? { signal } : undefined);
};
